(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired76b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired76b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRequire("ioqnc");
parcelRequire("2lior");
parcelRequire("2txD2");
parcelRequire("ixw25");

var $imjxJ = parcelRequire("imjxJ");

var $gHQDN = parcelRequire("gHQDN");

var $ixw25 = parcelRequire("ixw25");

var $8pgbe = parcelRequire("8pgbe");

var $e3CjK = parcelRequire("e3CjK");

var $gFS1C = parcelRequire("gFS1C");

var $lmFhk = parcelRequire("lmFhk");

var $d7crU = parcelRequire("d7crU");

var $goE6W = parcelRequire("goE6W");

var $6TCM2 = parcelRequire("6TCM2");

var $jLXwr = parcelRequire("jLXwr");
const { startPage: $f31bd6e8732f4dad$var$startPage } = (0, $gFS1C.paginationSettings);
const $f31bd6e8732f4dad$var$itemsPerPage = 20;
(0, $imjxJ.btnLibraryMoviesRefs).watchedBtn.addEventListener("click", $f31bd6e8732f4dad$var$onClickWatchedBtn);
(0, $imjxJ.btnLibraryMoviesRefs).queueBtn.addEventListener("click", $f31bd6e8732f4dad$var$onClickQueueBtn);
function $f31bd6e8732f4dad$var$addHeaderCurrentUser() {
    const user = (0, $gHQDN.getDataFromLocalStorage)("auth");
    (0, $imjxJ.authRefs).currentUser.style.display = "block";
    (0, $imjxJ.authRefs).currentUser.textContent = user.displayName;
}
$f31bd6e8732f4dad$var$addHeaderCurrentUser();
async function $f31bd6e8732f4dad$var$onClickWatchedBtn() {
    (0, $imjxJ.btnLibraryMoviesRefs).queueBtn.classList.remove("active-movie-list");
    (0, $imjxJ.btnLibraryMoviesRefs).watchedBtn.classList.add("active-movie-list");
    const { watchedList: watchedList } = await (0, $jLXwr.getFirebaseData)();
    (0, $d7crU.createCurrentPageFromStorage)($f31bd6e8732f4dad$var$startPage, "WATCHED_MOVIES", "");
    const staticPage = (0, $6TCM2.createLibraryPage)(watchedList, 1, $f31bd6e8732f4dad$var$itemsPerPage);
    (0, $ixw25.checkingForLibraryMoviesAndRender)((0, $imjxJ.moviesListRefs).libraryMoviesList, await (0, $lmFhk.getMoviesListOnLibrary)(staticPage), (0, $8pgbe.movieListStubTitles).watched, watchedList.length);
    (0, $e3CjK.initPagination)($f31bd6e8732f4dad$var$startPage, $f31bd6e8732f4dad$var$itemsPerPage, watchedList.length);
}
async function $f31bd6e8732f4dad$var$onClickQueueBtn() {
    (0, $imjxJ.btnLibraryMoviesRefs).watchedBtn.classList.remove("active-movie-list");
    (0, $imjxJ.btnLibraryMoviesRefs).queueBtn.classList.add("active-movie-list");
    const { queueList: queueList } = await (0, $jLXwr.getFirebaseData)();
    (0, $d7crU.createCurrentPageFromStorage)($f31bd6e8732f4dad$var$startPage, "QUEUE_MOVIES", "");
    const staticPage = (0, $6TCM2.createLibraryPage)(queueList, 1, $f31bd6e8732f4dad$var$itemsPerPage);
    (0, $ixw25.checkingForLibraryMoviesAndRender)((0, $imjxJ.moviesListRefs).libraryMoviesList, await (0, $lmFhk.getMoviesListOnLibrary)(staticPage), (0, $8pgbe.movieListStubTitles).queue, queueList.length);
    (0, $e3CjK.initPagination)($f31bd6e8732f4dad$var$startPage, $f31bd6e8732f4dad$var$itemsPerPage, queueList.length);
}
async function $f31bd6e8732f4dad$var$libraryRender() {
    const currentPage = (0, $goE6W.getDataFromSessionStorage)("currentSetPagination");
    const { watchedList: watchedList, queueList: queueList } = await (0, $jLXwr.getFirebaseData)();
    (0, $imjxJ.headerLinkRefs).library.classList.add("header-link-active");
    if (!currentPage) {
        (0, $imjxJ.btnLibraryMoviesRefs).watchedBtn.classList.add("active-movie-list");
        (0, $d7crU.createCurrentPageFromStorage)($f31bd6e8732f4dad$var$startPage, "WATCHED_MOVIES", "");
        const staticPage = (0, $6TCM2.createLibraryPage)(watchedList, $f31bd6e8732f4dad$var$startPage, $f31bd6e8732f4dad$var$itemsPerPage);
        (0, $ixw25.checkingForLibraryMoviesAndRender)((0, $imjxJ.moviesListRefs).libraryMoviesList, await (0, $lmFhk.getMoviesListOnLibrary)(staticPage), (0, $8pgbe.movieListStubTitles).watched, watchedList.length);
        (0, $e3CjK.initPagination)($f31bd6e8732f4dad$var$startPage, $f31bd6e8732f4dad$var$itemsPerPage, watchedList.length);
        return;
    }
    if (currentPage.type !== "QUEUE_MOVIES") {
        (0, $imjxJ.btnLibraryMoviesRefs).watchedBtn.classList.add("active-movie-list");
        (0, $d7crU.createCurrentPageFromStorage)(currentPage.page || $f31bd6e8732f4dad$var$startPage, "WATCHED_MOVIES", "");
        const staticPage = (0, $6TCM2.createLibraryPage)(watchedList, currentPage.page || $f31bd6e8732f4dad$var$startPage, $f31bd6e8732f4dad$var$itemsPerPage);
        (0, $ixw25.checkingForLibraryMoviesAndRender)((0, $imjxJ.moviesListRefs).libraryMoviesList, await (0, $lmFhk.getMoviesListOnLibrary)(staticPage), (0, $8pgbe.movieListStubTitles).watched, watchedList.length);
        (0, $e3CjK.initPagination)(currentPage.page, $f31bd6e8732f4dad$var$itemsPerPage, watchedList.length);
    }
    if (currentPage.type === "QUEUE_MOVIES") {
        (0, $imjxJ.btnLibraryMoviesRefs).queueBtn.classList.add("active-movie-list");
        (0, $d7crU.createCurrentPageFromStorage)(currentPage.page || $f31bd6e8732f4dad$var$startPage, "QUEUE_MOVIES", "");
        const staticPage = (0, $6TCM2.createLibraryPage)(queueList, currentPage.page || $f31bd6e8732f4dad$var$startPage, $f31bd6e8732f4dad$var$itemsPerPage);
        (0, $ixw25.checkingForLibraryMoviesAndRender)((0, $imjxJ.moviesListRefs).libraryMoviesList, await (0, $lmFhk.getMoviesListOnLibrary)(staticPage), (0, $8pgbe.movieListStubTitles).queue, queueList.length);
        (0, $e3CjK.initPagination)(currentPage.page, $f31bd6e8732f4dad$var$itemsPerPage, queueList.length);
    }
}
$f31bd6e8732f4dad$var$libraryRender();


parcelRequire("e3CjK");
parcelRequire("h2V5u");
parcelRequire("1Ep8q");
parcelRequire("7Olfg");
parcelRequire("7ZSN0");

})();
//# sourceMappingURL=library.ca1b4fdc.js.map
